export const productStatic = {
  id: 1,
  company: 'Sneaker Company',
  name: 'Fall Limited Edition Sneakers',
  about:
    'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nemo natus, veritatis quas, ipsum corporis nostrum, minus blanditiis obcaecati provident assumenda facere velit?',
  price: 250,
  discount: 0.5,
  images: [
    './assets/images/image-product-1.jpg',
    './assets/images/image-product-2.jpg',
    './assets/images/image-product-3.jpg',
    './assets/images/image-product-4.jpg',
  ],
  thumbnails: [
    './assets/images/image-product-1-thumbnail.jpg',
    './assets/images/image-product-2-thumbnail.jpg',
    './assets/images/image-product-3-thumbnail.jpg',
    './assets/images/image-product-4-thumbnail.jpg',
  ],
};
